import CodeBlock from '@tiptap/extension-code-block';
import { PrismPlugin } from './prism-plugin';
export const CodeBlockPrism = CodeBlock.extend({
    addOptions() {
        return {
            ...this.parent?.(),
            defaultLanguage: null,
        };
    },
    addProseMirrorPlugins() {
        return [
            ...this.parent?.() || [],
            PrismPlugin({
                name: this.name,
                defaultLanguage: this.options.defaultLanguage,
            }),
        ];
    },
});
